import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";

import type { GeneralAnmClassificationResponse } from "./generalAnmClassification.types";

const GENERAL_ANM_CLASSIFICATION_QUERY_KEY = "general-anm-classification";

export const getGeneralStructureAnmClassification = async (
  structureId: string,
): Promise<GeneralAnmClassificationResponse> =>
  axiosGetData<GeneralAnmClassificationResponse>(
    `v1/general/structures/${structureId}/anm-classification`,
  );

export const generalStructureAnmClassificationQueryOptions = (structureId: string) => ({
  queryKey: [GENERAL_ANM_CLASSIFICATION_QUERY_KEY, structureId],
  queryFn: () => getGeneralStructureAnmClassification(structureId),
});

export const useGeneralStructureAnmClassificationQuery = (
  structureId: string | undefined,
  options?: Partial<UseQueryOptions<GeneralAnmClassificationResponse, AxiosError>>,
) =>
  useQuery<GeneralAnmClassificationResponse, AxiosError>({
    ...generalStructureAnmClassificationQueryOptions(structureId ?? ""),
    enabled: Boolean(structureId),
    ...options,
  });
